import React from 'react';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import LoadingIcon from 'Components/LoadingIcon';
import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';

import CourseVariantSelector, { CourseVariantSelectorProps } from 'Modules/CourseVariantSelector';
import CourseInformation, { CourseInformationProps } from 'Modules/CourseInformation';
import CourseApply, { CourseApplyProps } from 'Modules/CourseApply';
import CourseCompare from 'Modules/CourseCompare';
import CourseHeroBanner, {
    Props as CourseHeroProps
} from 'Modules/HeroBanner/MakeWaves/Image/Course';

export interface Props {
    loading?: boolean;
    breadcrumbs: BreadcrumbsProps;
    heroBanner: CourseHeroProps;
    courseVariantSelector?: CourseVariantSelectorProps;
    courseInformation?: CourseInformationProps;
    courseApply?: CourseApplyProps;
    children?: React.ReactNode;
}

const Course: React.FC<Props> = props => {
    const {
        loading,
        breadcrumbs,
        heroBanner,
        courseVariantSelector,
        courseInformation,
        children,
        courseApply
    } = props;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <CourseHeroBanner {...heroBanner} />
            {courseVariantSelector && (
                <Section id="course-variant-selector" padding="none">
                    <CourseVariantSelector {...courseVariantSelector} />
                </Section>
            )}
            {loading && <LoadingIcon />}
            <div style={loading ? { opacity: 0.1 } : undefined}>
                {courseInformation && (
                    <Section padding="none" id="course-information">
                        <CourseInformation {...courseInformation} />
                    </Section>
                )}
                {children}
            </div>
            {courseApply && !loading && (
                <Section id="apply" paddingTop={0} paddingBottom={1}>
                    <Grid>
                        <Col l={[2, 12]}>
                            <CourseApply {...courseApply} />
                        </Col>
                    </Grid>
                </Section>
            )}
            <CourseCompare />
        </Main>
    );
};

export default Course;
